// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import { ConfigProvider } from './context/ConfigContext';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Map from './components/Map';
import About from './components/About';
import Help from './components/Help';
import WetlandsInfo from './components/WetlandsInfo';
import WetlandForm from './components/WetlandForm';
import WelcomeModal from './components/WelcomeModal';
import Footer from './components/Footer';
import './App.css';

function App() {
  const [showReportForm, setShowReportForm] = useState(false);
  const [refreshMap, setRefreshMap] = useState(0);
  const [newPinLocation, setNewPinLocation] = useState(null);
  const [showWelcome, setShowWelcome] = useState(
    !sessionStorage.getItem('welcomeDismissed')
  );

  const handleWelcomeClose = () => {
    sessionStorage.setItem('welcomeDismissed', 'true');
    setShowWelcome(false);
  };

  const handleReportClick = () => {
    setNewPinLocation(null); // Clear any previous pin location
    setShowReportForm(true);
  };

  const handleAddNewWetland = (location) => {
    setNewPinLocation(location);
    setShowReportForm(true);
  };

  const handleFormClose = () => {
    setShowReportForm(false);
    setNewPinLocation(null); // Clear pin location on close
  };

  const handleFormSuccess = () => {
    setRefreshMap(prev => prev + 1);
  };

  return (
    <ConfigProvider>
      <LanguageProvider>
        <Router>
          <div className="App">
            <Header onReportClick={handleReportClick} />
            <Navigation onReportClick={handleReportClick} />
            <main className="app-main">
              <Routes>
                <Route path="/" element={<Map key={refreshMap} onAddNewWetland={handleAddNewWetland} />} />
                <Route path="/about" element={<About />} />
                <Route path="/help" element={<Help />} />
                <Route path="/wetlands-info" element={<WetlandsInfo />} />
              </Routes>
            </main>
            {showReportForm && (
              <WetlandForm
                onClose={handleFormClose}
                onSuccess={handleFormSuccess}
                initialLocation={newPinLocation}
              />
            )}
            {showWelcome && (
              <WelcomeModal onClose={handleWelcomeClose} />
            )}
            <Footer />
          </div>
        </Router>
      </LanguageProvider>
    </ConfigProvider>
  );
}

export default App;
